import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container mx-auto px-4" }
const _hoisted_2 = { class: "w-full text-sm" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-b-2" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, "Network Info"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, "Quality")
  ])
], -1)
const _hoisted_4 = { class: "p-4" }
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = { class: "font-bold ml-2" }
const _hoisted_7 = { class: "p-4" }
const _hoisted_8 = { class: "inline-flex" }

import { getQualityScore } from '@/composables/video-diagnostic/useGetQualityScore'
import { QualityScore } from '@/types/enums/video-diagnostic.enum'
import { computed, reactive } from 'vue'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'QualityCard',
  setup(__props) {

const { t } = useI18n()
const { latency, jitter, packetLoss, bitrate } = getQualityScore()
const networkInfo = reactive({
  rtt: {
    topic: 'RTT',
    info: t('video-diagnostic.network-info.rtt'),
    score: latency,
  },
  jitter: {
    topic: 'Jitter',
    info: t('video-diagnostic.network-info.jitter'),
    score: jitter,
  },
  packetLoss: {
    topic: 'Packet loss',
    info: t('video-diagnostic.network-info.packet-lost'),
    score: packetLoss,
  },
  bitrate: {
    topic: 'Bitrate',
    info: t('video-diagnostic.network-info.bit-rate'),
    score: bitrate,
  },
})

const score = (payload) => {
  return `${QualityScore[payload.score.qualityScore]}`
}

const icon = (qualityScore) => {
  if (qualityScore === QualityScore.Excellent) {
    return 'bg-blue-500'
  }
  if (qualityScore === QualityScore.Good) {
    return 'bg-green-500'
  }
  if (qualityScore === QualityScore.Suboptimal) {
    return 'bg-yellow-500'
  }
  if (qualityScore === QualityScore.Poor) {
    return 'bg-red-500'
  }
}
const displayQualityStatus = (value) => {
  return `${t(`video-diagnostic.quality-status.${score(value)}`)}`
}

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(networkInfo, (value, key) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: key,
            class: "border-b-2"
          }, [
            _createElementVNode("td", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Popper, {
                  hover: true,
                  arrow: true,
                  content: value.info
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SvgIcon, {
                      icon: 'info',
                      "inherit-fill": true,
                      height: "16"
                    })
                  ]),
                  _: 2
                }, 1032, ["content"]),
                _createElementVNode("p", _hoisted_6, _toDisplayString(value.topic), 1)
              ])
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: _normalizeClass([icon(value.score.qualityScore), "rounded-full p-2 w-2 h-2 mr-2"])
                }, null, 2),
                _createElementVNode("p", null, _toDisplayString(displayQualityStatus(value)), 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})